import React from 'react'

const ContactUs = ({ text = 'Contattaci' }) => (
  <svg
    width="168"
    height="168"
    x="0px"
    y="0px"
    viewBox="0 0 168 168"
    enableBackground="new 0 0 168 168"
  >
    <circle fill="#F1F1F1" cx="84" cy="84" r="84" />
    <g transform="translate(45.000000, 45.000000)">
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="-1305.7985"
        y1="13.3664"
        x2="-1305.0901"
        y2="14.1983"
        gradientTransform="matrix(29 0 0 29 37918 -385)"
      >
        <stop offset="0" style={{ stopColor: '#F49593' }} />
        <stop offset="1" style={{ stopColor: '#F7BF28' }} />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M71.9,33c-1.1,0-2.1-0.9-2.1-2.1C69.8,18.3,59.6,8.1,47,8.1c-1.1,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1c14.9,0.1,27,12.2,27,27C74,32.1,73.1,33,71.9,33z"
      />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="-1336.3707"
        y1="-3.2683"
        x2="-1335.7328"
        y2="-3.8911"
        gradientTransform="matrix(101 0 0 101 134990 392)"
      >
        <stop offset="0" style={{ stopColor: '#4D4096' }} />
        <stop offset="1" style={{ stopColor: '#237AC0' }} />
      </linearGradient>
      <circle fill="url(#SVGID_2_)" cx="39.5" cy="39.5" r="50.5" />
      <g transform="translate(14.000000, 15.000000)">
        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1="-1359.4807"
          y1="-0.8939"
          x2="-1358.4441"
          y2="1.105875e-02"
          gradientTransform="matrix(72 0 0 72 97885 72.9961)"
        >
          <stop offset="0" style={{ stopColor: '#6EC18A' }} />
          <stop offset="1" style={{ stopColor: '#0E89CA' }} />
        </linearGradient>
        <path
          fill="url(#SVGID_3_)"
          d="M37.1,33.5l-5.9,7.3c-9.1-5.3-16.7-12.9-22-22l7.3-5.9c1.8-1.4,2.4-3.8,1.4-5.9L11.3-8c-1-2.2-3.4-3.4-5.8-2.8L-7.3-7.5c-2.4,0.6-4,3-3.7,5.5c4.6,32.7,30.3,58.4,63,63c2.5,0.3,4.9-1.2,5.5-3.7l3.3-12.7c0.6-2.4-0.6-4.8-2.8-5.8L43,32C40.9,31.1,38.5,31.7,37.1,33.5z"
        />
      </g>
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1="-1309.7073"
        y1="11.2783"
        x2="-1309.0806"
        y2="11.8429"
        gradientTransform="matrix(32 0 0 32 41962 -352)"
      >
        <stop offset="0" style={{ stopColor: '#6EC18A' }} />
        <stop offset="1" style={{ stopColor: '#0E89CA' }} />
      </linearGradient>
      <path
        fill="url(#SVGID_4_)"
        d="M72.8,36c-0.7,0-1.2-0.6-1.2-1.2c0-15.6-12.7-28.3-28.3-28.3c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C60.2,4,74,17.8,74,34.8C74,35.4,73.4,36,72.8,36z"
      />
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1="-1275.3019"
        y1="30.8074"
        x2="-1274.6752"
        y2="31.3719"
        gradientTransform="matrix(17 0 0 17 21727 -502)"
      >
        <stop offset="0" style={{ stopColor: '#6EC18A' }} />
        <stop offset="1" style={{ stopColor: '#0E89CA' }} />
      </linearGradient>
      <path
        fill="url(#SVGID_5_)"
        d="M57.8,36c-0.7,0-1.2-0.5-1.2-1.2c0-7.4-6-13.3-13.4-13.4c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2C51.9,19,59,26.1,59,34.8C59,35.5,58.5,36,57.8,36z"
      />
    </g>
    <text transform="matrix(1 0 0 1 48.4807 153)" fill="#2798B9">
      {text}
    </text>
  </svg>
)

export default ContactUs
